<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs />
        <div class="table-agile-info">
          <!--列表部分 start -->
          <el-table :data="tableData" :show-header="false" border stripe style="width: 100%">
            <el-table-column prop="title" label="" width="280">
            </el-table-column>
            <el-table-column prop="value" label="">
            </el-table-column>
          </el-table>
          <!--列表部分 end-->
          <div align="center" style="padding:10px">
            <el-button class="jm-input-common3" @click="$router.back()">返回</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';

export default {
  data() {
    return {
      tableData: {},
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  mounted() {
    this.$http._post({
      url: `/index/offer/projectDetail/id/${this.id}`
    }).then(({ data }) => {
      this.tableData = data;
    }).catch(() => {

    });
  },
  methods: {
  },
  components: {
    'jm-crumbs': crumbs,
  }
};
</script>

